
export default function AboutSection() {
  const stats = [
    { value: '15', label: 'Jaar Ervaring' },
    { value: '100+', label: 'Tevreden Klanten' }
  ];

  return (
    <section id="over-ons" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="grid grid-cols-2 gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/b95a4bb059a9a67a9cb54e050b67db9a.jpg" 
              alt="Dakwerken" 
              className="w-full h-64 object-cover rounded-lg"
            />
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20insulated%20attic%20interior%20with%20wooden%20beams%20and%20professional%20thermal%20insulation%20installation%2C%20bright%20natural%20lighting%2C%20clean%20construction%20environment%2C%20high%20quality%20materials%2C%20detailed%20craftsmanship%2C%20residential%20renovation%20project%2C%20professional%20photography&width=400&height=500&seq=lba-about-2&orientation=portrait" 
              alt="Isolatie" 
              className="w-full h-64 object-cover rounded-lg"
            />
          </div>

          <div className="text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Over LBA Construct
            </h2>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Met meer dan 15 jaar ervaring in de bouwsector is LBA Construct uitgegroeid tot een betrouwbare partner voor al uw dakwerken, isolatie, gyproc en loodgieterij projecten in Merksem en omgeving.
            </p>
            <p className="text-gray-400 mb-8 leading-relaxed">
              Ons team van gecertificeerde vakmensen staat garant voor kwaliteit, betrouwbaarheid en een persoonlijke aanpak bij elk project.
            </p>

            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl md:text-4xl font-bold text-blue-400 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-400">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
